
import {getSupportView} from '../api/getSupportView';
import {setGetSupportViewAction} from '../action';

const setGetSupportView = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getSupportView(params);

            if (data.status === 'success') {
                dispatch(setGetSupportViewAction(data.data));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetSupportView
}